export default "__VITE_ASSET__CfMnT6CO__"